module.exports = __webpack_public_path__ + "img/img_07.11b3bc63.jpg";